import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import ShareableFeedbackPage from './pages/ShareableFeedbackPage';

import LandingPage from './pages/LandingPage';
import TenantLogin from './pages/TenantLogin';
import TenantRegister from './pages/TenantRegister';
import TenantDashboard from './pages/TenantDashboard';
import FeedbackTakerLogin from './pages/FeedbackTakerLogin';
import FeedbackTakerDashboard from './pages/FeedbackTakerDashboard';
import UserFeedbackPage from './pages/UserFeedbackPage';
import Website from "./pages/Website";

const RedirectIfAuth = ({ children, role }) => {
    const { user, isAuthenticated } = useAuth();
    if (isAuthenticated && user?.role === role) {
        return <Navigate to={role === 'tenant' ? '/tenant/dashboard' : '/feedback-taker/dashboard'} replace />;
    }
    return children;
};

const ProtectedRoute = ({ children, role }) => {
    const { user, isAuthenticated } = useAuth();
    if (!isAuthenticated) return <Navigate to="/" replace />;
    if (role && user?.role !== role) return <Navigate to="/" replace />;
    return children;
};

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/tenant/login" element={<RedirectIfAuth role="tenant"><TenantLogin /></RedirectIfAuth>} />
                    <Route path="/tenant/registerwithadminrights" element={<RedirectIfAuth role="tenant"><TenantRegister /></RedirectIfAuth>} />
                    <Route
                        path="/tenant/dashboard/*"
                        element={
                            <ProtectedRoute role="tenant">
                                {/* Invisible Safe Area Spacer */}
                                <div className="ios-safe-area-spacer" />
                                <TenantDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/feedback-taker/login" element={<RedirectIfAuth role="feedbackTaker"><FeedbackTakerLogin /></RedirectIfAuth>} />
                    <Route
                        path="/feedback-taker/dashboard/*"
                        element={
                            <ProtectedRoute role="feedbackTaker">
                                {/* Invisible Safe Area Spacer */}
                                <div className="ios-safe-area-spacer" />
                                <FeedbackTakerDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/feedback/:sessionCode" element={<UserFeedbackPage />} />
                    <Route path="/f/:sessionCode" element={<ShareableFeedbackPage />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
